import { render } from "./addBank.vue?vue&type=template&id=345a15f0&scoped=true"
import script from "./addBank.vue?vue&type=script&lang=js"
export * from "./addBank.vue?vue&type=script&lang=js"

import "./addBank.vue?vue&type=style&index=0&id=345a15f0&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-345a15f0"]])

export default __exports__